import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import UsuarioService from '../../services/usuario.service';
import { AuthenticationService } from '../../services/authentication.service';
import toast, { Toaster } from 'react-hot-toast';
import './MisDatos.css';
import { MdClear } from "react-icons/md";

const PopupMisDatos = (props) => {
	
	const { t } = useTranslation("global");
	
	const authenticationService = new AuthenticationService();
	
	const [idUsuario, setIdUsuario] = useState(0);
	const [nombreUsuario, setNombreUsuario] = useState('');
	const [apellidos, setApellidos] = useState('');
	const [telefono, setTelefono] = useState('');
	const [nif, setNif] = useState('');
	var [esValido, setValido] = useState(true);
	
	
	const [nombreUsuarioError, setNombreUsuarioError] = useState('');
	const [apellidosError, setApellidosError] = useState('');
	const [telefonoError, setTelefonoError] = useState('');
	const [nifError, setNifError] = useState('');

	const toastGenericErrorLogin = () => toast.error(t('app.error.login.generic'));
	
	useEffect(() => {
		/*Para los campos del PopUp de mis datos*/
		setIdUsuario(props.connectedUser.id)
		setNombreUsuario(props.connectedUser.nombre);
		setApellidos(props.connectedUser.apellidos);
		setTelefono(props.connectedUser.telefono);
		setNif(props.connectedUser.nif);

	}, []);
	
	/*Al hacer submit en formulari de popup misDatos*/
	function handleLogin(e) {
		e.preventDefault()
		
		// Code to handle login goes here
		
		if(esValido) {
			props.toggle()	
		}
		
	}
	
	/*Evento para validar formulario popup misDatos*/
	function validateForm(usuario) {
		
		setNombreUsuarioError('');
		setApellidosError('');
		setTelefonoError('');
		setNifError('');
		
		
		
		if(usuario.nombre === '') {
			setNombreUsuarioError(t('app.error.campoObligatorio'))
			setValido(false);
			return;
			
		}
		
		if (usuario.apellidos === '') {
			setApellidosError(t('app.error.campoObligatorio'))
			setValido(false);
			return;
			
		}
		
		if(usuario.telefono === '') {
			setTelefonoError(t('app.error.campoObligatorio'))
			setValido(false);
			return;
		}
		
		if(usuario.nif === '') {
			setNifError(t('app.error.campoObligatorio'))
			setValido(false);
			return;
		}
		
			updateUsuario(usuario);
		
	}
	
	const guardarUsuario = async () => {
		
		editarUsuario();
	}
	
	const editarUsuario = async () => {
		const usuario = {
			id: idUsuario,
			idTipo: props.connectedUser.idTipo,
			nombre: nombreUsuario,
			apellidos: apellidos,
			telefono: telefono,
			email: props.connectedUser.email,
			activo: props.connectedUser.activo,
			nif: nif
		};
		
		validateForm(usuario)
	}
	
	const updateUsuario = async (usuario) => {
		await UsuarioService.actualizarUsuario(usuario)
			.then((response) => {
				if(response.status === 200) {
					props.toggle();
					props.loadUserAuthenticated();
				} else {
					toastGenericErrorLogin();
				}
			})
			.catch((err) => {
				toastGenericErrorLogin();
			});
	}
	
	const cancelarUsuario = () => {
		props.toggle();
	}
	
	return(<div className="popup">
			<div className="popup-inner">
				<div className="popup-Header">
					<h1 className={"popup-Title"}>{t("app.popup.label.editarPerfil")}</h1>
					<button className="popup-btn-x" onClick={props.toggle}><MdClear /></button>
				</div>
				
				<div className="popup-Content">
					<form onSubmit={handleLogin}>
						<div className="popup-div-inputs-popup">
							<div className={'inputContainerUsuario'}>
								<input placeholder={t("app.popup.label.nombre")} type="text" value={nombreUsuario} onChange={e => setNombreUsuario(e.target.value)} />
								<label className="errorLabel">{nombreUsuarioError}</label>
							</div>
							
							<div className={'inputContainerUsuario'}>
								<input placeholder={t("app.popup.label.apellidos")} type="text" value={apellidos} onChange={e => setApellidos(e.target.value)} />
								<label className="errorLabel">{apellidosError}</label>
							</div>
							
							<div className={'inputContainerUsuario'}>
								<input placeholder={t("app.popup.label.telefono")} type="text" value={telefono} onChange={e => setTelefono(e.target.value)} />
								<label className="errorLabel">{telefonoError}</label>
							</div>
							
							<div className={'inputContainerUsuario'}>
								<input placeholder={t("app.popup.label.nif")} type="text" value={nif} onChange={e => setNif(e.target.value)} />
								<label className="errorLabel">{nifError}</label>
							</div>
							
							
							<div className="popup-div-buttons">
								<button type="button" className="btn-general-colorPink" onClick={cancelarUsuario}>{t("app.label.cancelar")}</button>
								<button type="submit" className="btn-general" onClick={guardarUsuario}>{t("app.label.guardar")}</button>
							</div>
						</div>
					</form>
				</div>
				
				
			</div>
			</div>)
	
}

export default PopupMisDatos